import React, { useState } from 'react'

// components
import {
  CCol,
  CFormLabel,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CFormFeedback
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilLockLocked } from '@coreui/icons'

const FormPassword = ({
  id,
  name,
  colSize,
  className,
  inputLabel,
  placeholder = 'Password',
  value,
  handleTextInput,
  handleBlur,
  feedbackInvalid,
  invalid,
  combinationIndex,
  disabled,
  autoFocus = false,
  autoComplete = 'new-password'
}) => {
  const [showPassword, setShowPassword] = useState(false)

  return (
    <CCol lg={colSize} className={className}>
      {inputLabel && (
        <CFormLabel>
          {inputLabel}
        </CFormLabel>
      )}
      <CInputGroup>
        <CInputGroupText>
          <CIcon icon={cilLockLocked} />
        </CInputGroupText>
        <CFormInput
          id={id}
          name={name}
          placeholder={placeholder}
          type={showPassword ? 'text' : 'password'}
          value={value}
          onChange={(e) => handleTextInput(e, combinationIndex)}
          onBlur={handleBlur}
          autoFocus={autoFocus}
          autoComplete={autoComplete}
          disabled={disabled}
          invalid={invalid}
        />
        <CInputGroupText
          role="button"
          tabIndex={0}
          style={{ cursor: 'pointer' }}
          title={showPassword ? 'Hide password' : 'Show password'}
          onClick={() => setShowPassword((prev) => !prev)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              setShowPassword((prev) => !prev)
            }
          }}
        >
          {showPassword ? <svg
              width={16}
              height={16}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a20.87 20.87 0 0 1 5.06-6.06" />
              <path d="M9.9 4.24A10.94 10.94 0 0 1 12 4c7 0 11 8 11 8a20.87 20.87 0 0 1-3.22 4.44" />
              <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
              <line x1="1" y1="1" x2="23" y2="23" />
            </svg> : <svg
              width={16}
              height={16}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
              <circle cx="12" cy="12" r="3" />
            </svg>
          }
        </CInputGroupText>
        {invalid && feedbackInvalid && (
          <CFormFeedback invalid className="d-block">
            {feedbackInvalid}
          </CFormFeedback>
        )}
      </CInputGroup>
    </CCol>
  )
}

export default FormPassword